//@ts-nocheck
import globalConfig from '../config/globalConfig';

const DEFAULT_MAX_IMAGE_SIZE = 20 * 1024 * 1024;
export const STOCK_PHOTO_MAX_IMAGE_SIZE = 20 * 1024 * 1024;
const DEFAULT_MAX_FILE_SIZE = 10 * 1024 * 1024;
const DEFAULT_MAX_PASSENGER_FIELD_UPLOAD_SIZE = 20 * 1024 * 1024;

const resolveMaxSize = (value, fallback) => {
  const parsedValue = Number(value);

  return Number.isFinite(parsedValue) && parsedValue > 0
    ? parsedValue
    : fallback;
};

export const fileType = {
  IMAGE: 'image',
  FILE: 'file',
  VIDEO: 'video',
  AUDIO: 'audio'
};

export const pathReference = {
  TRIP: 'trip',
  DAY_ITENERARY: 'dayItenerary',
  CONTENT: 'content',
  DETAILED_DAY: 'detailedDay',
  DETAILED_DAY_SERVICE: 'detailedDayService',
  LIBRARY: 'library'
};

export const imageSize = {
  blured: { size: 200, prefix: 'BL' },
  thumbnail: { size: 400, prefix: 'TH' },
  small: { size: 600, prefix: 'SM' },
  medium: { size: 1204, prefix: 'MD' },
  large: { size: 2048, prefix: 'LG' }
};

export const imageRoute = {
  trip: {
    route: 'tenant/{tenantid}/trip/{tripid}'
  },
  dayItenerary: {
    route: 'tenant/{tenantid}/trip/{tripid}/tripdayitinerary'
  },
  content: {
    route: `tenant/{tenantid}/trip/{tripid}/tripcontent`
  },
  detailedDay: {
    route: 'tenant/{tenantid}/trip/{tripid}/tripdetailedday'
  },
  detailedDayService: {
    route: 'tenant/{tenantid}/trip/{tripid}/tripdetaileddayservice'
  },
  library: {
    route: 'tenant/{tenantid}/library'
  }
};

export const maxImageSize = resolveMaxSize(
  globalConfig?.maxImageSize,
  DEFAULT_MAX_IMAGE_SIZE
);
export const maxFileSize = resolveMaxSize(
  globalConfig?.maxFileSize,
  DEFAULT_MAX_FILE_SIZE
);
export const maxImages = 5;
export const maxAttachments = 1;
export const maxPassengerFieldUploadFiles = 5;
export const maxPassengerFieldUploadSize =
  DEFAULT_MAX_PASSENGER_FIELD_UPLOAD_SIZE;

export const supportedAttachmentMimeTypes = [
  'application/msword',
  'application/pdf',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'image/gif',
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/webp',
  'text/csv'
];

export const supportedAttachmentExtensions = [
  '.csv',
  '.doc',
  '.docx',
  '.gif',
  '.jpeg',
  '.jfif',
  '.jpg',
  '.pdf',
  '.png',
  '.webp',
  '.xls',
  '.xlsx'
];

export const supportedAttachmentAccept = [
  ...supportedAttachmentMimeTypes,
  ...supportedAttachmentExtensions
].join(',');
